import { Injectable } from "@angular/core";

declare let ga: Function; // Declare ga as a function

@Injectable({ providedIn: "root" })
export class GoogleAnalyticsService {
    private window; 

    constructor (private windowRef: WindowReferenceService)
    {
        this.window = windowRef.nativeWindow; // intialise the window to what we get from our window service

    }

    // create our event emitter to send our data to google analytics
    //public eventEmitter(eventCategory: string, eventAction: string, eventLabel: string = null, eventValue: number = null) {
    //    ga("send", "event", {
    //        eventCategory: eventCategory,
    //        eventLabel: eventLabel,
    //        eventAction: eventAction,
    //        eventValue: eventValue
    //    });

    //    ga("studentPortalTracker.send", "event", {
    //        eventCategory: eventCategory,
    //        eventLabel: eventLabel,
    //        eventAction: eventAction,
    //        eventValue: eventValue
    //    });
    //}

    private pingHome(obj)
    {
        if(obj) this.window.dataLayer.push(obj);
    }
   
    logPageView(url)
    {
        const hit = {
            event: "content_view",
            pageName: url
        };
        this.pingHome(hit);
    }

    logEvent(event: string,eventCategory: string, eventAction: string, eventLabel: string = null)
    {
        const hit = {
            event:event,
            category:eventCategory,
            action:eventAction,
            label: eventLabel
        }
        this.pingHome(hit);
    }

}

function getWindow():any {
    return window;
}

@Injectable({
    providedIn: "root"
})
export class WindowReferenceService {
    get nativeWindow() {
        return getWindow();
    }
}